<div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
  <h2 mat-dialog-title style="margin-bottom: 0">{{'CREATE' | translate}}</h2>
  <button mat-icon-button (click)="onNoClick()" style="margin-right: 12px"><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content style="min-width: 280px; padding-left: 0; padding-right: 0; padding-top: 0">

  <div>
    <mat-stepper
      class="example-stepper"
      [orientation]="(stepperOrientation | async)!" linear="true" #stepper
      (selectionChange)="checkStepValidation($event)">

      <mat-step [stepControl]="firstFormGroup" label="{{'TEMPLATE' | translate}}">
        <form [formGroup]="firstFormGroup">
          <div class="input-box" style="margin-bottom: 12px;">
            <span class="input-field-label" [ngClass]="{'disabled-template-data' : isTemplateDisabled()}">{{'CHOOSE_TEMPLATE' | translate}}*</span>
            <mat-form-field class="field-width" subscriptSizing="dynamic">
              <mat-select formControlName="templateCtrl"
                          required #templateSelector
                          (selectionChange)="onTemplateSelected($event.value)"
                          placeholder="{{'NOT_SELECTED' | translate}}">
                <mat-option *ngFor="let template of templates" [value]="template">{{template.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="firstFormGroup.get('templateCtrl')?.errors?.['required']">
                {{'MANDATORY_FIELD' | translate}}
              </mat-error>
              <mat-hint *ngIf="isTemplateLoading">{{'DATA_LOADING' | translate}}</mat-hint>
            </mat-form-field>
          </div>
          <button mat-button style="margin: 0 0 12px" (click)="stepper.reset();resetTemplate()" *ngIf="actualTemplate&&!isTemplateLoading">
            {{'Másik sablon választása' | translate}}
          </button>
          <div [ngClass]="{'disabled-template-data' : !templateSelector.value}">
            <p class="desc-title" [ngClass]="{'disabled-template-data' : !templateSelector.value}">
              {{'NAME' | translate}}
            </p>
            <p style="margin-bottom: 20px">{{templateName ? templateName : '-'}}</p>
            <p class="desc-title" [ngClass]="{'disabled-template-data' : !templateSelector.value}">
              {{'DESCRIPTION' | translate}}
            </p>
            <div *ngIf="!templateDescription">{{'NO_DESCRIPTION' | translate}}</div>
            <div *ngIf="templateDescription" [innerHTML]="trustHtml(templateDescription)" style="width: 100%"></div>
          </div>
          <div style="margin-top: 20px">
            <button mat-stroked-button (click)="openDiagram()"
                    [disabled]="!actualTemplate || isTemplateLoading">
              {{'DIAGRAM' | translate}}
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="secondFormGroup" label="{{'INFORMATION' | translate}}" optional="true">
        <ng-template matStepContent>
          <form [formGroup]="secondFormGroup">
            <div class="input-box-unset-width">
              <span class="input-field-label">{{'SUBJECT' | translate}}*</span>
              <mat-form-field>
                <input matInput formControlName="subjectCtrl"
                       required (input)="onSubjectChange($event)">
                <mat-error *ngIf="secondFormGroup.get('subjectCtrl')?.hasError('required')">
                  {{'MANDATORY_FIELD' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div style="width: 100%; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
              <p class="desc-title">{{'DESCRIPTION' | translate}}</p>
              <button mat-icon-button (click)="showEditor()" [disabled]="isEditor"><mat-icon>edit</mat-icon></button>
            </div>
            <mat-form-field style="width: 100%" *ngIf="!isEditor">
              <textarea matInput formControlName="descriptionCtrl"></textarea>
            </mat-form-field>
            <quill-editor class="content-editor" formControlName="descriptionCtrl" style="width: 100%; margin-bottom: 22px" *ngIf="isEditor"></quill-editor>
            <div class="wf-data-div">
              <!--
              <div class="input-box">
                <span class="input-field-label">{{'RELATED_ITEM_TYPE' | translate}}</span>
                <mat-form-field *ngIf="actualTemplate">
                  <mat-select (selectionChange)="enableRelatedItem($event.value)" placeholder="{{'NOT_SELECTED' | translate}}" formControlName="relatedItemTypeCtrl">
                    <mat-option [value]="null">{{'NOT_SELECTED' | translate}}</mat-option>
                    <mat-option *ngFor="let item of actualTemplate!.allowedLinkedItemTypes" [value]="item">{{item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="input-box">
                <span class="input-field-label">{{'RELATED_ITEM' | translate}}</span>
                <mat-form-field>
                  <input matInput #inputRelatedItem formControlName="relatedItemCtrl" (blur)="onBlurRelatedItem(inputRelatedItem.value)"
                         [placeholder]="relatedItemPlaceholder">
                  <mat-error *ngIf="secondFormGroup.get('relatedItemCtrl')?.hasError('pattern') && !isRelatedItemSearchActive">
                    {{'WRONG_FORMAT' | translate}}
                  </mat-error>
                  <mat-error *ngIf="secondFormGroup.get('relatedItemCtrl')?.hasError('required') && !isRelatedItemSearchActive">
                    {{'MANDATORY_FIELD' | translate}}
                  </mat-error>
                  <mat-error *ngIf="secondFormGroup.get('relatedItemCtrl')?.hasError('itemNotExist') && !isRelatedItemSearchActive">
                    {{'RELATED_ITEM_NOT_EXIST' | translate}}
                  </mat-error>
                  <mat-hint *ngIf="isRelatedItemSearchActive">{{'SEARCHING_FOR_RELATED_ITEM' | translate}}</mat-hint>
                </mat-form-field>
              </div>
              -->
              <div class="input-box">
                <span class="input-field-label">{{'DEADLINE' | translate}}*</span>
                <mat-form-field *ngIf="actualTemplate" class="field-width">
                  <input matInput
                         [matDatepicker]="picker"
                         placeholder="YYYY. MM. DD."
                         required
                         [min]="minDate"
                         formControlName="deadlineCtrl"
                         (dateChange)="setDeadline($event.value)">
                  <mat-datepicker-toggle matIconSuffix [for]="picker" class="icon-button"></mat-datepicker-toggle>
                  <mat-datepicker touchUi="true" #picker></mat-datepicker>
                  <mat-error *ngIf="secondFormGroup.get('deadlineCtrl')?.hasError('required')">
                    {{'MANDATORY_FIELD' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-box">
                <span class="input-field-label">{{'RESPONSIBLE_USER' | translate}}*</span>
                <mat-form-field class="field-width">
                  <mat-icon matPrefix>search</mat-icon>
                  <input #input
                         type="text"
                         placeholder="{{'SEARCHING_FOR_PERSON' | translate}}"
                         matInput
                         required
                         [formControl]="myControl"
                         [matAutocomplete]="auto"
                         (input)="searchResponsiblePeople(input.value)">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" requireSelection="true"
                                    (optionSelected)="setResponsibleUser($event.option.value)">
                    <mat-option *ngIf="notFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                      {{option.userName}} ({{option.orgName}})
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="myControl.hasError('required')">
                    {{'MANDATORY_FIELD' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>
        </ng-template>
      </mat-step>

      <mat-step [completed]="metaStepCompleted" [hasError]="metaStepHasError" *ngIf="showMetadata"
                label="{{ 'META_DATA' | translate }}" optional="true">
        <ng-template matStepContent>
          <p *ngIf="!actualTemplate || !actualTemplate.metadata || actualTemplate.metadata.length === 0" class="upload-title">
            {{'NO_META_DATA' | translate}}
          </p>
          <div class="wf-data-div" *ngIf="actualTemplate">
            <ng-container *ngFor="let item of actualTemplate.metadata">
              <ng-container *ngIf="item.visibility==='MT_M'||item.visibility==='MT_K'||item.visibility==='MT_O'">
                <ng-container [ngSwitch]="item.type">
                  <app-meta-data-check *ngSwitchCase="'Check'"
                                       [label]="item.name"
                                       [visibility]="item.visibility"
                                       [(humanvalue)]="item.humanvalue"
                                       [(value)]="item.value"></app-meta-data-check>

                  <app-meta-data-date *ngSwitchCase="'Date'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-date>

                  <app-meta-data-partner *ngSwitchCase="'Partner'"
                                         [label]="item.name"
                                         [visibility]="item.visibility"
                                         [(humanvalue)]="item.humanvalue"
                                         [(value)]="item.value"></app-meta-data-partner>

                  <app-meta-data-alszam *ngSwitchCase="'Alszam'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value"></app-meta-data-alszam>

                  <app-meta-data-foszam *ngSwitchCase="'Foszam'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value"></app-meta-data-foszam>

                  <app-meta-data-mftorzs *ngSwitchCase="'MFTorzs'"
                                         [label]="item.name"
                                         [visibility]="item.visibility"
                                         [mfTorzsOptionList]="mfTorzsOptionList"
                                         [(humanvalue)]="item.humanvalue"
                                         [(value)]="item.value" [params]="item.params"></app-meta-data-mftorzs>

                  <app-meta-data-mftorzs-ac *ngSwitchCase="'MFTorzsAC'"
                                            [label]="item.name"
                                            [visibility]="item.visibility"
                                            [mfTorzsOptionList]="mfTorzsOptionList"
                                            [(humanvalue)]="item.humanvalue"
                                            [(value)]="item.value" [params]="item.params"></app-meta-data-mftorzs-ac>

                  <app-meta-data-money *ngSwitchCase="'Money'"
                                       [label]="item.name"
                                       [visibility]="item.visibility"
                                       [(humanvalue)]="item.humanvalue"
                                       [(value)]="item.value"></app-meta-data-money>

                  <app-meta-data-number *ngSwitchCase="'Number'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value"></app-meta-data-number>

                  <app-meta-data-text *ngSwitchCase="'Text'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-text>

                  <app-meta-data-link *ngSwitchCase="'Link'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-link>

                  <app-meta-data-option *ngSwitchCase="'Option'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value" [default]="item.params"></app-meta-data-option>

                  <app-meta-data-textarea *ngSwitchCase="'Textarea'"
                                          [label]="item.name"
                                          [visibility]="item.visibility"
                                          [(humanvalue)]="item.humanvalue"
                                          [(value)]="item.value"></app-meta-data-textarea>

                  <app-meta-data-workflow *ngSwitchCase="'Workflow'"
                                          [label]="item.name"
                                          [visibility]="item.visibility"
                                          [(humanvalue)]="item.humanvalue"
                                          [(value)]="item.value"></app-meta-data-workflow>

                  <app-meta-data-szotar *ngSwitchCase="'Szotar'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [szotarOptionList]="szotarOptionList"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value" [params]="item.params"></app-meta-data-szotar>

                  <app-meta-data-szotar-ac *ngSwitchCase="'SzotarAC'"
                                           [label]="item.name"
                                           [visibility]="item.visibility"
                                           [szotarOptionList]="szotarOptionList"
                                           [(humanvalue)]="item.humanvalue"
                                           [(value)]="item.value" [params]="item.params"></app-meta-data-szotar-ac>

                  <app-meta-data-szervuser *ngSwitchCase="'SzervUser'"
                                           [label]="item.name"
                                           [visibility]="item.visibility"
                                           [(humanvalue)]="item.humanvalue"
                                           [(value)]="item.value"></app-meta-data-szervuser>

                  <app-meta-data-szervuser-ac *ngSwitchCase="'SzervUserAC'"
                                              [label]="item.name"
                                              [visibility]="item.visibility"
                                              [(humanvalue)]="item.humanvalue"
                                              [(value)]="item.value"></app-meta-data-szervuser-ac>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="fourthFormGroup" label="{{'ATTACHMENTS' | translate}} {{countAttachments()}}"
                [completed]="false" optional="true">
        <ng-template matStepContent>
          <form [formGroup]="fourthFormGroup">
            <div>
              <p class="upload-title">{{'FILE_UPLOAD' | translate}}</p>
              <div class="dropzone"
                   [ngClass]="{ 'dragover': isDragOver }"
                   (drop)="onFileDrop($event)"
                   (dragover)="onDragOver($event)"
                   (dragleave)="onDragLeave($event)">
                <input type="file" id="fileDropRef" multiple
                       style="opacity: 0; position: relative; z-index: 2; width: 100%; height: 100%; top: 0; left: 0;"
                       (change)="uploadingFiles($event)">
                <p class="dropzone-text">{{'CHOOSE_A_FILE' | translate}}</p>
              </div>
              <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 22px" class="custom-expansion-attachment" togglePosition="before" expanded="true" [disabled]="uploadFileList.length === 0">
                <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                  <mat-panel-title>{{'ATTACHMENTS' | translate}} ({{uploadFileList.length}})</mat-panel-title>
                </mat-expansion-panel-header>
<!--                <mat-list style="padding: 0">-->
<!--                  <div *ngFor="let file of uploadFileList; let i = index">-->
<!--                    <mat-list-item style="padding-left: 0" class="unset-list-item attacment-meta">-->
<!--                      <div matListItemTitle class="unset-title">{{file.content.name}}</div>-->
<!--                      <div matListItemLine>{{formatFileSize(file.content.size)}}</div>-->
<!--                      <div matListItemLine *ngIf="file.content.size > MAX_FILE_SIZE" style="color: #ED2447">{{'FILE_TOO_LARGE' | translate}}</div>-->
<!--                      <div matListItemMeta style="display: flex; flex-direction: row; align-items: center; justify-content: center; height: 100%" class="unset-meta-item">-->
<!--                        <mat-form-field subscriptSizing="dynamic" class="uploaded-file-type">-->
<!--                          <mat-select placeholder="{{'ATTACHMENT_TYPE' | translate}}" [(value)]="file.attachmentTypeCode" style="line-height: 2">-->
<!--                            <mat-option [value]="null">-->
<!--                              {{'NOT_SELECTED' | translate}}-->
<!--                            </mat-option>-->
<!--                            <mat-option *ngFor="let fileType of attachmentTypes" [value]="fileType.code">-->
<!--                              {{fileType.name}}-->
<!--                            </mat-option>-->
<!--                          </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <button mat-icon-button (click)="removeFile(i)" class="delete-button">-->
<!--                          <mat-icon>delete</mat-icon>-->
<!--                        </button>-->
<!--                      </div>-->
<!--                    </mat-list-item>-->
<!--                    <mat-divider class="line-divider"></mat-divider>-->
<!--                  </div>-->
<!--                </mat-list>-->
                <div *ngFor="let file of uploadFileList; let i = index" class="uploaded-file-div">
                  <div class="uploaded-file-inner-div">
                    <div class="uploaded-file-name"
                         [ngClass]="{'error-color': file.content.size > MAX_FILE_SIZE}">
                      {{file.content.name}}
                      <span class="uploaded-file-size"> ({{formatFileSize(file.content.size)}})</span>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-evenly">
                      <mat-form-field subscriptSizing="dynamic" class="uploaded-file-type">
                        <mat-select placeholder="{{'ATTACHMENT_TYPE' | translate}}" [(value)]="file.attachmentTypeCode">
                          <mat-option [value]="null">
                            {{'NOT_SELECTED' | translate}}
                          </mat-option>
                          <mat-option *ngFor="let fileType of attachmentTypes" [value]="fileType.code">
                            {{fileType.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-icon-button class="error-color" (click)="removeFile(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <mat-divider class="line-divider"></mat-divider>
                </div>
              </mat-expansion-panel>
            </div>
          </form>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </div>

</mat-dialog-content>
<mat-dialog-actions style="display: flex; flex-direction: row; align-items: center;">
  <button mat-button [disabled]="stepper.selectedIndex === 0" (click)="stepper.previous()">
    {{'BACK' | translate}}
  </button>
  <button mat-button [disabled]="stepper.selectedIndex === stepper.steps.length - 1 || firstFormGroup.invalid"
          (click)="stepper.next()">
    {{'NEXT' | translate}}
  </button>
  <span class="example-spacer"></span>
  <button mat-flat-button [disabled]="!isAllFormValid() || isUploading" (click)="createWorkflow()">
    {{'CREATE' | translate}}
  </button>
</mat-dialog-actions>
